var getg = function() {
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    return {};
// 全局对象不存在
// throw new Error('no global object');
};
export var g = getg();
/** sdk内部使用 */ export var pandaSelf = {
    debug: false
};
/** 当前是否时在浏览器环境下 */ export var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined";
